import { AnnouncementTypeMetadataMap } from '@/lib/announcement-utils';
import { Announcement } from '@airreading/common/data';
import clsx from 'clsx';

export interface AnnouncementContentProps {
  announcement: Announcement;
  shouldShowIcon?: boolean;
}

export const AnnouncementContent = ({ announcement, shouldShowIcon = true }: AnnouncementContentProps) => {
  const { title, content, type } = announcement;
  const metadata = AnnouncementTypeMetadataMap[type];
  const { icon, bgClass } = metadata;

  return (
    <div className={clsx('text-sm flex items-center gap-3 py-3 px-4 rounded-md', bgClass)}>
      {shouldShowIcon && icon}
      <div>
        {title && <p className="font-semibold">{title}</p>}
        <p>{content}</p>
      </div>
    </div>
  );
};
